module.exports = __webpack_public_path__ + "img/preventivi.7eebcdb2.svg";